// extracted by mini-css-extract-plugin
export default {"fullWidth":"t5-z","image":"u5-z","lazyLoadPicture":"v5-z","lazyLoadSpinner":"w5-z","lazyLoadSpin":"x5-z","lazyLoadImage":"y5-z","hasStyledAspectRatio":"z5-z"};